<template>
  <div class="contract-change-bd">
    <div class="change-title ub ub-sp">
      <el-radio-group v-model="formSearch.changeState" @change="onPageChange({page: 1})">
        <el-radio-button label>{{ $t('Common.com_all') }}</el-radio-button>
        <el-radio-button
          v-for="(item, i) in propertyMap.crm_contract_change_state"
          :key="i"
          :label="item.value"
        >{{item.name}}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        tableCode="contractChange"
        @filter="filterChange"
        @sort="sortChange"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'contract_change',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formSearch: {
        bizId: '',
        changeState: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
    };
  },
  // created: function () {
  //   this.Bus.$on('contract_detail', this.getTableList);
  // },
  // destroyed() {
  //   this.Bus.$off('contract_detail', this.getTableList);
  // },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId');
    this.getTableList();
    this.getDictionary('crm_contract_change_state');
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.ContractChange, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang='scss'>
@import 'style/colors.scss';

.contract-change-bd {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
